import { inject, provideAppInitializer } from '@angular/core'

import { RuntimeConfigService } from '@yoshu-lib/core/config/runtime-config.service'
import { DEFAULT_FEATURES, FeatureMap } from '@yoshu-lib/core/feature-flags/feature-flags.model'
import { FeatureFlagsService } from '@yoshu-lib/core/feature-flags/feature-flags.service'
import { Environment, ENVIRONMENT } from '@yoshu-lib/core/tokens/environment.token'

import { environment } from '@aubertduval/env/environment'

const mergedEnvironment: Environment = {
  ...environment,
  features: { ...DEFAULT_FEATURES, ...environment.features } as FeatureMap
}

async function initializeEnvironment(
  runtimeConfigService: RuntimeConfigService,
  featureFlagsService: FeatureFlagsService
) {
  const runtimeConfig = await runtimeConfigService.loadConfig()

  if (runtimeConfig.apiUrl) {
    mergedEnvironment.apiUrl = runtimeConfig.apiUrl
  }
  if (runtimeConfig.socketUrl) {
    mergedEnvironment.socketUrl = runtimeConfig.socketUrl
  }
  if (runtimeConfig.tenantId) {
    mergedEnvironment.tenantId = runtimeConfig.tenantId
  }
  if (runtimeConfig.serviceApiKey) {
    mergedEnvironment.serviceApiKey = runtimeConfig.serviceApiKey
  }
  if (runtimeConfig.features) {
    ;(mergedEnvironment as { features: FeatureMap }).features = {
      ...mergedEnvironment.features,
      ...runtimeConfig.features
    } as FeatureMap
    featureFlagsService.update(runtimeConfig.features as Partial<FeatureMap>)
  }
  runtimeConfigService.markConfigApplied()
}

export const provideEnvironment = () => {
  return [
    provideAppInitializer(() =>
      initializeEnvironment(inject(RuntimeConfigService), inject(FeatureFlagsService))
    ),
    {
      provide: ENVIRONMENT,
      useFactory: () => mergedEnvironment
    }
  ]
}
